"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const scalars_1 = require("../../../graphql/scalars");
const type_graphql_1 = require("type-graphql");
const FeatureFlags_1 = require("../../../entities/core/FeatureFlags");
let AppSettingsUpdateInput = class AppSettingsUpdateInput {
};
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], AppSettingsUpdateInput.prototype, "allowSignups", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], AppSettingsUpdateInput.prototype, "enableMagicLinks", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], AppSettingsUpdateInput.prototype, "allowUsersToCreateWorkspaces", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], AppSettingsUpdateInput.prototype, "requireWorkspacesToHavePaymentMethod", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => type_graphql_1.ID, { nullable: true }),
    tslib_1.__metadata("design:type", Number)
], AppSettingsUpdateInput.prototype, "appUser", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], AppSettingsUpdateInput.prototype, "removeHideablesOnCampaignSend", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], AppSettingsUpdateInput.prototype, "removeOsysTagsOnCampaignSend", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => Boolean),
    tslib_1.__metadata("design:type", Boolean)
], AppSettingsUpdateInput.prototype, "minifyOnCampaignSend", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => scalars_1.GraphQLJSON),
    tslib_1.__metadata("design:type", Object)
], AppSettingsUpdateInput.prototype, "minifySettings", void 0);
tslib_1.__decorate([
    type_graphql_1.Field(() => scalars_1.GraphQLJSON),
    tslib_1.__metadata("design:type", FeatureFlags_1.FeatureFlags)
], AppSettingsUpdateInput.prototype, "featureFlagOverrides", void 0);
AppSettingsUpdateInput = tslib_1.__decorate([
    type_graphql_1.InputType()
], AppSettingsUpdateInput);
exports.AppSettingsUpdateInput = AppSettingsUpdateInput;
//# sourceMappingURL=index.js.map